/* eslint-disable array-callback-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Modal, Space, Input, Card, Table, Select, Button, List, Typography, Form, Collapse, Image, Menu, notification } from 'antd';

import { CheckCircleOutlined, ExclamationCircleOutlined, PrinterOutlined } from '@ant-design/icons';

import moment from 'moment';
import { toast } from 'react-toastify';

import { Container } from './styles';
import api from '~/services/api';

import GetRates from './GetRates';
import PrintLabel from './PrintLabel';
import PrintCustomsForm from './PrintCustomsForm';
import CountryList from '~/utils/countriesList';
import ShipmentInfo from './ShipmentInfo';
import ConfigureShipment from './ConfigureShipment';
import Shipments from './Shipments';
import OtherOptions from './OtherOptions';
import Customs from './Customs';
import history from '~/services/history';

const { confirm } = Modal;

export default function OrderShipment({ match }) {
  const [orderNumber, setOrderNumber] = useState('');
  const [orderInfo, setOrderInfo] = useState({});

  const [internationalOptions, setInternationalOptions] = useState({});
  // const [internationalOptions, setInternationalOptions] = useState({
  // contents: 'merchandise',
  // customsItems: [
  // {
  //   description: null,
  //   quantity: null,
  //   value: null,
  //   harmonizedTariffCode: '8471.30.10',
  //   countryOfOrigin: null,
  // },
  //   ],
  //   nonDelivery: 'return_to_sender',
  // });

  const [shipmentInfo, setShipmentInfo] = useState({});
  const [shipments, setShipments] = useState([]);

  const [shippingAccount, setShippingAccount] = useState('primary');

  const [visibleGetRates, setVisibleGetRates] = useState(false);
  const [visiblePrintLabel, setVisiblePrintLabel] = useState(false);
  const [visibleCustomsForm, setVisibleCustomsForm] = useState(false);

  const [editAddress, setEditAddress] = useState(false);
  const [country, setCountry] = useState('US');
  const [recipient, setRecipient] = useState({});

  const [carriersAndServices, setCarriersAndServices] = useState([]);

  const [warehouse, setWarehouse] = useState(7609);
  const [serviceCode, setServiceCode] = useState();
  const [packageCode, setPackageCode] = useState('package');
  const [confirmationCode, setConfirmationCode] = useState('none');

  const [warehouses, setWarehouses] = useState([]);
  const [warehousesList, setWarehousesList] = useState([]);

  const [infoToCalculateRate, setInfoToCalculateRate] = useState({});
  const [labelForOrderInfo, setLabelForOrderInfo] = useState({});

  const [lbWeight, setLbWeight] = useState(0);
  const [ozWeight, setOzWeight] = useState(0);

  const [length, setLength] = useState();
  const [width, setWidth] = useState();
  const [height, setHeight] = useState();

  const [countries, setCountries] = useState([]);

  const [loadingRate, setLoadingRate] = useState(false);

  const [splitShipBtnDisabled, setSplitShipBtnDisabled] = useState(true);

  const nameRef = useRef();
  const companyRef = useRef();
  const addressLine1Ref = useRef();
  const addressLine2Ref = useRef();
  const addressLine3Ref = useRef();
  const cityRef = useRef();
  const stateRef = useRef();
  const postalCodeRef = useRef();
  const phoneRef = useRef();
  const emailRef = useRef();

  const { Title, Paragraph } = Typography;
  const { Panel } = Collapse;

  const openNotification = () => {
    notification.info({
      message: `Slip Ship Notification`,
      description: 'You can ship from ShipStation',
      placement: 'top',
      duration: 6,
    });
  };

  useEffect(() => {
    async function loadCountries() {
      const countryList = CountryList();
      countryList.splice(
        countryList.findIndex(el => el.value === 'CA'),
        1
      );
      countryList.splice(
        countryList.findIndex(el => el.value === 'US'),
        1
      );
      countryList.splice(0, 0, { value: 'US', label: 'United States of America (the)' });
      countryList.splice(1, 0, { value: 'CA', label: 'Canada' });
      setCountries(countryList);
    }
    loadCountries();

    async function loadOrder() {
      const order = await api.get(`orders/${match.params.order_id}`);

      // const totalItemsPrice = order.data.order_items.reduce((acc, item) => acc + +item.unit_price, 0);

      order.data.totalProducts = order.data.order_items.reduce((acc, item) => acc + +item.unit_price * item.quantity, 0);

      if ((order.data.order_items.length > 1 || +order.data.order_items[0].quantity > 1) && order.data.status !== 'shipped') setSplitShipBtnDisabled(false);

      const shipmentList = await api.get(`shipstation/shipments?orderId=${order.data.shipstation_order_id}`);
      const exchange_rate = await api.get('exchange_rate_cad_to');
      setShipmentInfo(shipmentList.data.find(el => el.voided === false) || {});

      setShipments(shipmentList.data);

      setOrderInfo(order.data);
      setOrderNumber(order.data.order_num);
      setRecipient({
        name: order.data.customer.name,
        company: order.data.customer.company,
        country: order.data.customer.country,
        addressLine1: order.data.customer.street1,
        addressLine2: order.data.customer.street2,
        addressLine3: order.data.customer.street3,
        city: order.data.customer.city,
        state: order.data.customer.state,
        postalCode: order.data.customer.postalCode,
        phone: order.data.customer.phone,
        email: order.data.customer.email,
      });

      const newInternationalOptions = {
        contents: 'merchandise',
        customsItems: [],
        nonDelivery: 'return_to_sender',
      };
      order.data.order_items.map(item => {
        newInternationalOptions.customsItems.push({
          description: item.title.substr(0, 90),
          quantity: item.quantity,
          value: (order.data.customer.country !== 'CA' && order.data.store_id) !== 5 ? (item.unit_price / exchange_rate.data.usd).toFixed(2) : item.unit_price,
          harmonizedTariffCode: '8471.30.10',
          countryOfOrigin: null,
        });
      });

      setInternationalOptions(newInternationalOptions);
    }

    async function loadWarehouses() {
      const warehousesData = await api.get('shipstation/warehouses');
      setWarehouses(warehousesData.data.map(e => ({ value: e.warehouseId, label: e.warehouseName })));
      setWarehousesList(warehousesData.data);
      // setInfoToCalculateRate({
      //   ...infoToCalculateRate,
      //   fromPostalCode: warehousesData.data.find(el => el.warehouseId === warehouse)?.originAddress?.postalCode,
      // });
    }

    async function loadCarriersAndServices() {
      const carriersAndServicesList = await api.get('shipstation/carriers');

      setCarriersAndServices(carriersAndServicesList.data);
    }

    loadOrder();
    loadWarehouses();
    loadCarriersAndServices();
  }, []); //eslint-disable-line

  const columns = [
    {
      title: '',
      dataIndex: 'image_url',
      key: 'image_url',
      render: text => (
        <Image
          // preview={false}
          width={50}
          alt={text}
          src={text || 'error'}
          fallback="data:image/png;base64,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"
        />
      ),

      width: '5%',
    },
    {
      title: 'Order Item',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Unit Price',
      dataIndex: 'unit_price',
      key: 'unit_price',
      width: '5%',
    },
    {
      title: 'Qty',
      dataIndex: 'quantity',
      key: 'quantity',
      width: '5%',
      render: text => <Title level={2}>{text}</Title>,
    },
    {
      title: 'Total',
      dataIndex: 'total_price',
      key: 'total_price',
      width: '5%',
    },
  ];

  function handleShowGetRatesModal(status) {
    setVisibleGetRates(status);
  }

  function handleVisiblePrintLabel(status) {
    setVisiblePrintLabel(status);
  }

  function handleVisibleCustomsForm(status) {
    setVisibleCustomsForm(status);
  }

  const genExtra = () => (
    <Menu
      mode="horizontal"
      // onClick={event => {
      //   // If you don't want click extra trigger collapse, you can prevent this:
      //   event.stopPropagation();
      // }}
    >
      <Menu.SubMenu key="SubMenu" title="Print" icon={<PrinterOutlined />}>
        <Menu.Item key="label" onClick={() => handleVisiblePrintLabel(true)}>
          Print Label
        </Menu.Item>
        <Menu.Item key="form" onClick={() => handleVisibleCustomsForm(true)}>
          Print Customs Form
        </Menu.Item>
        {/* <Menu.ItemGroup title="Item Group">
          <Menu.Item key="four">Navigation Four</Menu.Item>
          <Menu.Item key="five">Navigation Five</Menu.Item>
        </Menu.ItemGroup> */}
      </Menu.SubMenu>
    </Menu>
    // <SettingOutlined
    //   onClick={event => {
    //     // If you don't want click extra trigger collapse, you can prevent this:
    //     event.stopPropagation();
    //   }}
    // />
  );

  // const genExtra = () => (
  //   <SettingOutlined
  //     onClick={event => {
  //       // If you don't want click extra trigger collapse, you can prevent this:
  //       event.stopPropagation();
  //     }}
  //   />
  // );

  const handleOzBlur = useCallback(
    ozValue => {
      let weightInOz = 0;
      if (ozValue > 15) {
        if (lbWeight) {
          setLbWeight(+lbWeight + Math.floor(+ozValue / 16));
          setOzWeight(ozWeight % 16);
          weightInOz = lbWeight * 16 + (+ozValue % 16);
          setInfoToCalculateRate({
            ...infoToCalculateRate,
            weight: {
              value: weightInOz,
              units: 'ounces',
            },
          });
          return;
        }
        setLbWeight(0 + Math.floor(+ozValue / 16));
        setOzWeight(ozWeight % 16);
        weightInOz = +ozValue;
        setInfoToCalculateRate({
          ...infoToCalculateRate,
          weight: {
            value: weightInOz,
            units: 'ounces',
          },
        });
        return;
      }
      weightInOz = +lbWeight * 16 + +ozValue;
      setOzWeight(+ozValue);

      setInfoToCalculateRate({
        ...infoToCalculateRate,
        weight: {
          value: weightInOz,
          units: 'ounces',
        },
      });
    },
    [infoToCalculateRate, lbWeight, ozWeight]
  );

  function handleOzChange(ozValue) {
    setOzWeight(+ozValue - Math.floor(+ozValue / 16) * 16);
  }

  function handleChangeWarehouse(warehouseId) {
    setWarehouse(warehouseId);
  }

  const handleSetGetRatesVisible = useCallback(() => {
    if ((lbWeight === undefined && ozWeight === undefined) || (lbWeight === 0 && ozWeight === 0)) {
      toast.error('Weight must be greater than zero');
      return;
    }

    if (!length && !width && !height) {
      toast.error('Must set the dimension first');
      return;
    }

    setVisibleGetRates(true);

    setLabelForOrderInfo({
      orderId: orderInfo.shipstation_order_id,
      // carrier,
      // service,
      packageCode: 'package',
      confirmation: 'none',
      shipDate: new Date(),
      weight: {
        value: lbWeight * 16 + ozWeight,
        // lbWeight && ozWeight
        //   ? +lbWeight * 16 + ozWeight
        //   : lbWeight === undefined && ozWeight
        //   ? ozWeight
        //   : ozWeight === undefined && lbWeight
        //   ? lbWeight * 16
        //   : 0,
        units: 'ounces',
      },
      dimensions: {
        units: 'inches',
        length: length || 0,
        width: width || 0,
        height: height || 0,
      },
      insuranceOptions: null,
      // internationalOptions,
      advancedOptions: {},
      testLabel: false,
    });

    setInfoToCalculateRate({
      carrierCode: null,
      serviceCode: null,
      packageCode,
      fromPostalCode: warehousesList.find(el => el.warehouseId === warehouse)?.originAddress?.postalCode,
      fromCity: warehousesList.find(el => el.warehouseId === warehouse)?.originAddress?.city,
      fromState: warehousesList.find(el => el.warehouseId === warehouse)?.originAddress?.state,
      toState: orderInfo?.customer?.state,
      toCountry: orderInfo.customer.country,
      toPostalCode: orderInfo.customer.postalCode,
      toCity: orderInfo?.customer?.city,
      weight: {
        value: lbWeight * 16 + ozWeight,
        // lbWeight && ozWeight
        //   ? +lbWeight * 16 + ozWeight
        //   : lbWeight === undefined && ozWeight
        //   ? ozWeight
        //   : ozWeight === undefined && lbWeight
        //   ? lbWeight * 16
        //   : 0,
        units: 'ounces',
      },
      dimensions: {
        units: 'inches',
        length: length || 0,
        width: width || 0,
        height: height || 0,
      },
      confirmation: confirmationCode,
      residential: orderInfo.customer.residential,
    });
  }, [confirmationCode, height, lbWeight, length, orderInfo, ozWeight, packageCode, warehouse, warehousesList, width]); //eslint-disable-line

  const handleChangeService = useCallback(
    async serviceId => {
      if (+lbWeight + +ozWeight <= 0 || Number.isNaN(+lbWeight + +ozWeight)) {
        toast.error('Must set the weight first');
        return;
      }

      setServiceCode(serviceId);

      setLoadingRate(true);

      const rate = await api.post('shipstation/getrates', {
        carrierCode: carriersAndServices.filter(carrier => carrier.services.some(item => item.code === serviceId)).map(carrier => carrier.code)[0],
        serviceCode: serviceId,
        packageCode,
        fromPostalCode: warehousesList.find(el => el.warehouseId === warehouse)?.originAddress?.postalCode,
        fromCity: warehousesList.find(el => el.warehouseId === warehouse)?.originAddress?.city,
        fromState: warehousesList.find(el => el.warehouseId === warehouse)?.originAddress?.state,
        toState: orderInfo.customer.state,
        toCountry: orderInfo.customer.country,
        toPostalCode: orderInfo.customer.postalCode,
        toCity: orderInfo.customer.city,
        weight: {
          value: lbWeight * 16 + ozWeight,
          // lbWeight && ozWeight
          //   ? +lbWeight * 16 + ozWeight
          //   : lbWeight === undefined && ozWeight
          //   ? ozWeight
          //   : ozWeight === undefined && lbWeight
          //   ? lbWeight * 16
          //   : 0,
          units: 'ounces',
        },
        dimensions: {
          units: 'inches',
          length: length || 0,
          width: width || 0,
          height: height || 0,
        },
        confirmation: confirmationCode,
        residential: orderInfo.customer.residential,
      });

      if (Object.keys(rate.data).length === 0) {
        if (rate.data.error) {
          toast.error(rate.data.error);
          return;
        }
        toast.error('Could not load rate');
        return;
      }

      // let internationalOptions = {};

      // if (orderInfo.customer.country !== 'CA') {
      //   internationalOptions = {
      //     contents: 'merchandise',
      //     customsItems: [
      //       {
      //         description: 'Test',
      //         quantity: 1,
      //         value: 1347.87,
      //         harmonizedTariffCode: '8471.30.10',
      //         countryOfOrigin: 'CN',
      //       },
      //     ],
      //     nonDelivery: 'return_to_sender',
      //   };
      // }

      setLabelForOrderInfo({
        ...rate.data,
        orderId: orderInfo.shipstation_order_id,
        carrierCode: carriersAndServices.filter(carrier => carrier.services.some(item => item.code === serviceId)).map(carrier => carrier.code)[0],
        serviceCode: serviceId,
        packageCode: 'package',
        confirmation: 'none',
        shipDate: new Date(),
        weight: {
          value: lbWeight * 16 + ozWeight,
          units: 'ounces',
        },
        dimensions: {
          units: 'inches',
          length: length || 0,
          width: width || 0,
          height: height || 0,
        },
        insuranceOptions: null,
        // internationalOptions,
        advancedOptions: {},
        testLabel: false,
      });

      setInfoToCalculateRate({
        carrierCode: carriersAndServices.filter(carrier => carrier.services.some(item => item.code === serviceId)).map(carrier => carrier.code)[0],
        serviceCode: serviceId,
        packageCode,
        fromPostalCode: warehousesList.find(el => el.warehouseId === warehouse)?.originAddress?.postalCode,
        fromCity: warehousesList.find(el => el.warehouseId === warehouse)?.originAddress?.city,
        fromState: warehousesList.find(el => el.warehouseId === warehouse)?.originAddress?.state,
        toState: orderInfo.customer.state,
        toCountry: orderInfo.customer.country,
        toPostalCode: orderInfo.customer.postalCode,
        toCity: orderInfo.customer.city,
        weight: {
          value: lbWeight * 16 + ozWeight,
          // lbWeight && ozWeight
          //   ? +lbWeight * 16 + ozWeight
          //   : lbWeight === undefined && ozWeight
          //   ? ozWeight
          //   : ozWeight === undefined && lbWeight
          //   ? lbWeight * 16
          //   : 0,
          units: 'ounces',
        },
        dimensions: {
          units: 'inches',
          length: length || 0,
          width: width || 0,
          height: height || 0,
        },
        confirmation: confirmationCode,
        residential: orderInfo.customer.residential,
      });
      setLoadingRate(false);
    },
    [carriersAndServices, confirmationCode, height, lbWeight, length, orderInfo, ozWeight, packageCode, warehouse, warehousesList, width]
  );

  async function handleCreateLabelCall(shippability) {
    try {
      const labelCreated = await api.post('shipstation/createLabelForOrder', {
        orderId: orderInfo.id,
        // warningOverride: true,
        labelData: { ...labelForOrderInfo, internationalOptions },
      });

      if (labelCreated.data.error) {
        toast.error(`3 - ${labelCreated.data.error.message}`);
        return;
      }

      setShipments([labelCreated.data, ...shipments]);
      setShipmentInfo(labelCreated.data);
      setOrderInfo({ ...orderInfo, status: 'shipped' });

      await api.put(`orders/${orderInfo.id}`, {
        shippability_checked: true,
        check_result: shippability.message,
      });

      // await api.patch('orders/sync', { orderNumber: orderInfo.order_num, storeId: orderInfo.store_id, fulfillmentChannel: 'NON-FBA' });
      await api.patch('orders/sync', {
        shipstationOrderId: orderInfo.shipstation_order_id,
        orderNumber: orderInfo.order_num,
        fulfillmentChannel: 'NON-FBA',
      });

      handleVisiblePrintLabel(true);

      toast.success('Label generated');
    } catch (error) {
      toast.error(error.data.response);
    }
  }

  async function handleGenerateLabel() {
    if (Object.keys(labelForOrderInfo).length === 0) {
      toast.error('Must calculate rate first');
      return;
    }
    setLabelForOrderInfo({ ...labelForOrderInfo, internationalOptions });
    let err = null;
    if (orderInfo.customer.country !== 'CA') {
      internationalOptions.customsItems.forEach(el => {
        if (el.countryOfOrigin === null || el.description === '' || el.quantity === '' || el.value === '') {
          err = true;
        }
      });
      if (err) {
        toast.error('Check customs items');
        return;
      }
    }

    if (labelForOrderInfo.serviceCode === undefined) {
      toast.error('Must choose a shipping service');
      return;
    }

    if (
      labelForOrderInfo.advancedOptions.billToParty === 'recipient' &&
      (labelForOrderInfo.advancedOptions.billToAccount === undefined ||
        labelForOrderInfo.advancedOptions.billToCountryCode === undefined ||
        labelForOrderInfo.advancedOptions.billToPostalCode === undefined)
    ) {
      toast.error('All shipping account information must be filled');
      return;
    }

    try {
      if (orderInfo.customer.country === 'CA' || orderInfo.store_id === 5) delete orderInfo.internationalOptions;

      const shippability = await api.get(`shipstation/checkShippability/${orderInfo.id}`, { headers: { checkType: 'order' } });

      if (shippability.data.type === 'warning') {
        confirm({
          title: shippability.data.message,
          icon: <ExclamationCircleOutlined />,
          content: 'Do you want to print the label anyway?',
          async onOk() {
            /** label Created With Warning */
            handleCreateLabelCall(shippability.data);
          },
          onCancel() {},
        });
      } else {
        handleCreateLabelCall(shippability.data);
      }
    } catch (error) {
      toast.error(error.data.response.message);
    }
  }

  async function handleVoidLabel() {
    try {
      const labelVoided = await api.post('shipstation/voidLabel', { shipmentId: shipmentInfo.shipmentId });

      if (labelVoided.data.approved) {
        const newShipments = [...shipments];
        newShipments.find(el => el.shipmentId === shipmentInfo.shipmentId).voided = true;
        setShipments(newShipments);
        setShipmentInfo({});
        setOrderInfo({ ...orderInfo, status: 'awaiting_shipment' });
        toast.success('Label voided');
        handleVisiblePrintLabel(false);
        return;
      }
      toast.error('Could not void label');
    } catch (error) {
      toast.error('Could not void lable due error');
    }
  }

  function handleChangeShippingAccount(value) {
    setShippingAccount(value);
    const labelInfo = { ...labelForOrderInfo };
    if (value === 'other') {
      labelInfo.advancedOptions.billToParty = 'recipient';
      setLabelForOrderInfo(labelInfo);
    } else {
      labelInfo.advancedOptions = {};
      setLabelForOrderInfo(labelInfo);
    }
  }

  const handleSplitShipCheck = async () => {
    try {
      const shippability = await api.get(`shipstation/checkShippability/${orderInfo.id}`, { headers: { checkType: 'order' } });

      if (shippability.data.type === 'warning') {
        confirm({
          title: shippability.data.message,
          icon: shippability.data.type === 'warning' ? <ExclamationCircleOutlined /> : <CheckCircleOutlined />,
          content: 'Do you want to confirm order is right?',
          async onOk() {
            await api.put(`orders/${orderInfo.id}`, {
              shippability_checked: true,
              check_result: shippability.data.message,
            });
            openNotification(shippability.data.message);
          },
          onCancel() {},
        });
      } else {
        await api.put(`orders/${orderInfo.id}`, {
          shippability_checked: true,
          check_result: shippability.data.message,
        });
        openNotification(shippability.data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  return (
    <Container>
      <Card size="small">
        <Space wrap style={{ display: 'flex' }} size={50}>
          <Button onClick={() => history.push(`/order/${orderInfo.id}`)} type="primary">
            Back to Details
          </Button>
          <Title level={3}>{orderNumber}</Title>
          {/* <Button type="primary">Export</Button> */}
        </Space>
      </Card>
      <Space align="top" direction="horizontal">
        <Space align="top" direction="vertical">
          <Card style={{ width: 680 }} title="Order Details" size="small" headStyle={{ fontWeight: 'bold' }}>
            <Space align="top">
              <Card style={{ width: 160 }} size="small" title="Dates">
                <List itemLayout="horizontal" split={false} size="small">
                  <List.Item>
                    <List.Item.Meta title="Order Date" description={moment(orderInfo.order_date).format('MMM DD, YYYY')} />
                  </List.Item>
                  <List.Item>
                    <List.Item.Meta title="Paid Date" description={moment(orderInfo.payment_date).format('MMM DD, YYYY')} />
                  </List.Item>
                  <List.Item>
                    <List.Item.Meta
                      title="Ship By"
                      description={moment(orderInfo.ship_by_date).isValid() && moment(orderInfo.ship_by_date).format('MMM DD, YYYY')}
                    />
                  </List.Item>
                  <List.Item>
                    <List.Item.Meta
                      title="Hold Until"
                      description={moment(orderInfo.hold_until_date).isValid() && moment(orderInfo.hold_until_date).format('MMM DD, YYYY')}
                    />
                  </List.Item>
                </List>
              </Card>

              <Card style={{ width: 160 }} size="small" title="Cost">
                <List itemLayout="horizontal" split={false} size="small">
                  <List.Item>
                    <List.Item.Meta
                      title="Product"
                      description={new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(orderInfo.totalProducts)}
                    />
                  </List.Item>
                  <List.Item>
                    <List.Item.Meta
                      title="Shipping"
                      description={new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(orderInfo.shipping_cost)}
                    />
                  </List.Item>
                  <List.Item>
                    <List.Item.Meta
                      title="Tax"
                      description={new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(orderInfo.tax_amount)}
                    />
                  </List.Item>
                  <List.Item>
                    <List.Item.Meta
                      title="Total"
                      description={new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(orderInfo.order_total)}
                    />
                  </List.Item>
                  {/* <List.Item>
                    <List.Item.Meta title="Total Paid" description={new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(orderInfo.totalProducts)} />
                  </List.Item> */}
                </List>
              </Card>

              <Card style={{ width: 320 }} size="small" title="Recipient">
                <List itemLayout="horizontal" split={false} size="small">
                  <List.Item>
                    <List.Item.Meta
                      title={<strong>Ship To</strong>}
                      description={
                        !editAddress && (
                          <>
                            <Paragraph>
                              <div>{recipient.name}</div>
                              <div>{recipient.company || ''}</div>
                              <div>{`${recipient.addressLine1 || ''} ${recipient.addressLine2 || ''} ${recipient.addressLine3 || ''}`}</div>
                              <div>{`${recipient.city}, ${recipient.state} ${recipient.postalCode || ''} ${recipient.country}`}</div>
                              <div>{recipient.phone || ''}</div>

                              <Button type="link" onClick={() => setEditAddress(true)}>
                                Edit
                              </Button>
                            </Paragraph>
                          </>
                        )
                      }
                    />
                  </List.Item>
                  {editAddress && (
                    <List.Item>
                      <Form
                        labelCol={{
                          span: 8,
                        }}
                        wrapperCol={{
                          span: 4,
                        }}
                        // layout="horizontal"
                        // initialValues={{
                        //   size: componentSize,
                        // }}
                        // onValuesChange={onFormLayoutChange}
                        size="small"
                      >
                        <Form.Item style={{ margin: '5px' }} label="Name">
                          <Input autoComplete="none" defaultValue={recipient.name} ref={nameRef} size="small" placeholder="Name" style={{ width: '180px' }} />
                        </Form.Item>
                        <Form.Item style={{ margin: '5px' }} label="Company">
                          <Input
                            autoComplete="none"
                            defaultValue={recipient.company}
                            ref={companyRef}
                            size="small"
                            placeholder="Company"
                            style={{ width: '180px' }}
                          />
                        </Form.Item>

                        <Form.Item style={{ margin: '5px' }} label="Country">
                          <Select
                            showSearch
                            value={country}
                            onChange={e => setCountry(e)}
                            size="small"
                            options={CountryList()}
                            optionFilterProp="children"
                            filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            placeholder="Country"
                            style={{ width: '180px' }}
                            autoComplete="none"
                          />
                        </Form.Item>
                        <Form.Item style={{ margin: '5px' }} label="Address">
                          <Input
                            defaultValue={recipient.addressLine1}
                            ref={addressLine1Ref}
                            autoComplete="none"
                            size="small"
                            placeholder="Address Line 1"
                            style={{ width: '180px' }}
                          />
                          <Input
                            defaultValue={recipient.addressLine2}
                            ref={addressLine2Ref}
                            autoComplete="none"
                            size="small"
                            placeholder="Address Line 2"
                            style={{ width: '180px' }}
                          />
                          <Input
                            defaultValue={recipient.addressLine3}
                            ref={addressLine3Ref}
                            autoComplete="none"
                            size="small"
                            placeholder="Address Line 3"
                            style={{ width: '180px' }}
                          />
                        </Form.Item>
                        <Form.Item style={{ margin: '5px' }} label="City">
                          <Input defaultValue={recipient.city} ref={cityRef} autoComplete="none" size="small" placeholder="City" style={{ width: '180px' }} />
                        </Form.Item>
                        <Form.Item style={{ margin: '5px' }} label="State">
                          <Input
                            defaultValue={recipient.state}
                            ref={stateRef}
                            autoComplete="none"
                            size="small"
                            placeholder="State"
                            style={{ width: '180px' }}
                          />
                        </Form.Item>
                        <Form.Item style={{ margin: '5px' }} label="Postal Code">
                          <Input
                            defaultValue={recipient.postalCode}
                            ref={postalCodeRef}
                            autoComplete="none"
                            size="small"
                            placeholder="Postal Code"
                            style={{ width: '180px' }}
                          />
                        </Form.Item>
                        <Form.Item style={{ margin: '5px' }} label="Phone">
                          <Input
                            defaultValue={recipient.phone}
                            ref={phoneRef}
                            autoComplete="none"
                            size="small"
                            placeholder="Phone"
                            style={{ width: '180px' }}
                          />
                        </Form.Item>
                        <Form.Item style={{ margin: '5px' }} label="Email">
                          <Input
                            defaultValue={recipient.email}
                            ref={emailRef}
                            autoComplete="none"
                            size="small"
                            placeholder="Email"
                            style={{ width: '180px' }}
                          />
                        </Form.Item>
                        <Space style={{ marginTop: '10px' }}>
                          <Button size="small" onClick={() => setEditAddress(false)}>
                            Cancel
                          </Button>
                          <Button
                            type="primary"
                            size="small"
                            onClick={() => {
                              setRecipient({
                                name: nameRef.current?.state?.value,
                                company: companyRef.current?.state?.value,
                                country,
                                addressLine1: addressLine1Ref.current?.state?.value,
                                addressLine2: addressLine2Ref.current?.state?.value,
                                addressLine3: addressLine3Ref.current?.state?.value,
                                city: cityRef.current?.state?.value,
                                state: stateRef.current?.state?.value,
                                postalCode: postalCodeRef.current?.state?.value,
                                phone: phoneRef.current?.state?.value,
                                email: emailRef.current?.state?.value,
                              });
                              setEditAddress(false);
                            }}
                          >
                            Save
                          </Button>
                        </Space>
                      </Form>
                    </List.Item>
                  )}
                  <List.Item>
                    <List.Item.Meta title="Sold To" description={`${recipient.name} \n ${recipient.email || ''}`} />
                  </List.Item>
                </List>
              </Card>
            </Space>
          </Card>

          <Card
            style={{ width: 680 }}
            title="Order Items"
            size="small"
            headStyle={{ fontWeight: 'bold' }}
            extra={
              <Button size="small" disabled={splitShipBtnDisabled} onClick={handleSplitShipCheck}>
                Split Ship Check
              </Button>
            }
          >
            <Table dataSource={orderInfo.order_items} rowKey="id" columns={columns} pagination={false} size="small" />
          </Card>
        </Space>

        <Collapse defaultActiveKey={['Shipments', 'Configure', 'Customs', 'ShipmentInfo', 'Other']} style={{ width: 500, marginTop: 10 }} collapsible="header">
          {/* <Collapse defaultActiveKey={['Customs']} style={{ width: 500, marginTop: 10 }}> */}
          {shipments.length > 0 && (
            <Panel header="Shipments" key="Shipments" forceRender extra={genExtra()}>
              <Shipments shipments={shipments} />
            </Panel>
          )}

          {Object.keys(shipmentInfo).length > 0 && (
            <Panel header="ShipmentInfo" key="ShipmentInfo">
              <ShipmentInfo shipmentInfo={shipmentInfo} handleVoidLabel={handleVoidLabel} />
            </Panel>
          )}

          {/* <Panel header="Configure Shipment" key="Configure">No shipment info</Panel> */}
          {shipments.filter(el => el.voided === false).length === 0 && orderInfo.status !== 'shipped' && (
            <Panel header="Configure Shipment" key="Configure">
              <ConfigureShipment
                warehouses={warehouses}
                warehouse={warehouse}
                lbWeight={lbWeight}
                setLbWeight={setLbWeight}
                ozWeight={ozWeight}
                handleOzChange={handleOzChange}
                serviceCode={serviceCode}
                packageCode={packageCode}
                setPackageCode={setPackageCode}
                recipient={recipient}
                length={length}
                setLength={setLength}
                width={width}
                setWidth={setWidth}
                height={height}
                setHeight={setHeight}
                confirmationCode={confirmationCode}
                setConfirmationCode={setConfirmationCode}
                labelForOrderInfo={labelForOrderInfo}
                handleChangeWarehouse={handleChangeWarehouse}
                handleSetGetRatesVisible={handleSetGetRatesVisible}
                handleOzBlur={handleOzBlur}
                handleChangeService={handleChangeService}
                handleGenerateLabel={handleGenerateLabel}
                carriersAndServices={carriersAndServices}
                loadingRate={loadingRate}
              />
            </Panel>
          )}

          {orderInfo.customer?.country !== 'CA' && (
            <Panel header="Customs Declarations" key="Customs">
              <Customs orderStatus={orderInfo.status} internationalOptions={internationalOptions} setInternationalOptions={setInternationalOptions} />
            </Panel>
          )}
          <Panel header="Other Shipping Options" key="Other">
            <OtherOptions
              shippingAccount={shippingAccount}
              handleChangeShippingAccount={handleChangeShippingAccount}
              countries={countries}
              labelForOrderInfo={labelForOrderInfo}
              setLabelForOrderInfo={setLabelForOrderInfo}
              setLoadingRate={setLoadingRate}
            />
          </Panel>
        </Collapse>
      </Space>

      {visibleGetRates && (
        <GetRates
          handleShowGetRatesModal={handleShowGetRatesModal}
          info={infoToCalculateRate}
          setLabelForOrderInfo={setLabelForOrderInfo}
          labelForOrderInfo={labelForOrderInfo}
          setServiceCode={setServiceCode}
          setConfirmationCode={setConfirmationCode}
          setInfoToCalculateRate={setInfoToCalculateRate}
          infoToCalculateRate={infoToCalculateRate}
        />
      )}

      {visiblePrintLabel && (
        <PrintLabel
          visiblePrintLabel={visiblePrintLabel}
          handleVisiblePrintLabel={handleVisiblePrintLabel}
          handleVoidLabel={handleVoidLabel}
          labelData={shipmentInfo.labelData}
          // label={shipmentInfo.label}
        />
      )}

      {visibleCustomsForm && (
        <PrintCustomsForm visibleCustomsForm={visibleCustomsForm} handleVisibleCustomsForm={handleVisibleCustomsForm} formData={shipmentInfo.formData} />
      )}
    </Container>
  );
}
